module.exports = __webpack_public_path__ + "img/dgjg2332_2.7083d3c1.svg";